module.exports = __webpack_public_path__ + "static/img/TH.11d6f089.jpg";